<template>
  <nav class="w-full bg-[#FF6333] text-white">
    <div class="p-2 flex flex-row justify-between items-center">
      <div>
        <img src="/frontend/static/norm_logo.svg" alt="Norm logo" class="h-5" />
      </div>
      <div class="text-sm flex gap-2">
        <div class="flex items-center">
          <UserIcon class="h-4 w-4" />
          <span>{{ auth.username }}</span>
        </div>

        <button
          class="text-xs bg-gray-200 text-black rounded-sm p-1"
          @click="auth.clearUserData()"
        >
          Log uit
        </button>
      </div>
    </div>
    <div class="flex items-end overflow-x-auto text-sm">
      <a
        v-if="canUseErp"
        :href="`${erpBaseUrl}/#/`"
        class="ml-2 md:ml-4 p-2 flex items-center gap-1"
      >
        <ArrowUturnLeftIcon class="h-4 w-4" />
        ERP
      </a>
      <RouterLink
        :to="{ name: 'tickets-list' }"
        class="ml-2 md:ml-4 p-2"
        :class="currentRoute === 'ticket' && 'bg-white text-black rounded-t'"
        v-if="
          auth.roles.some(
            (r) => r.includes('tickets_v2') || r.includes('admin')
          )
        "
      >
        Tickets
      </RouterLink>
      <RouterLink
        :to="{ name: 'calendar' }"
        class="ml-2 md:ml-4 p-2"
        :class="currentRoute === 'calendar' && 'bg-white text-black rounded-t'"
        v-if="
          auth.roles.some(
            (r) => r.includes('tickets_v2') || r.includes('admin')
          )
        "
      >
        Agenda
      </RouterLink>
      <RouterLink
        :to="{ name: 'schedule' }"
        class="ml-2 md:ml-4 p-2 hidden md:block"
        :class="currentRoute === 'schedule' && 'bg-white text-black rounded-t'"
        v-if="
          auth.roles.some(
            (r) => r.includes('tickets_v2') || r.includes('admin')
          )
        "
      >
        Kalender
      </RouterLink>
      <RouterLink
        :to="{ name: 'orders-list' }"
        class="ml-2 md:ml-4 text-white p-2"
        :class="currentRoute === 'order' && 'bg-white text-black rounded-t'"
        v-if="auth.roles.some((r) => r.includes('partner_order'))"
      >
        Logistiek
      </RouterLink>

      <RouterLink
        :to="{ name: 'installer-quotes' }"
        class="ml-2 md:ml-4 text-white p-2"
        :class="currentRoute === 'installer' && 'bg-white text-black rounded-t'"
        v-if="auth.hasPermission('Tickets:view_installer_quotes')"
      >
        Prijsopgaven
      </RouterLink>

      <RouterLink
        :to="{ name: 'address-book' }"
        class="ml-2 md:ml-4 text-white p-2"
        :class="
          currentRoute === 'address-book' && 'bg-white text-black rounded-t'
        "
        v-if="auth.hasPermission('Tickets:address_book')"
      >
        Adresboek
      </RouterLink>

      <RouterLink
        :to="{ name: 'planner' }"
        class="ml-2 md:ml-4 text-white p-2"
        :class="currentRoute === 'planner' && 'bg-white text-black rounded-t'"
        v-if="auth.hasPermission('Tickets:view_planner')"
      >
        PlanBaas
      </RouterLink>
      <RouterLink
        :to="{ name: 'buildings-list' }"
        class="ml-2 md:ml-4 p-2"
        :class="currentRoute === 'buildings' && 'bg-white text-black rounded-t'"
        v-if="
          auth.hasPermission('Tickets:view_buildings') ||
          auth.roles.some((r) => r.includes('admin'))
        "
      >
        Gebouwen
      </RouterLink>
      <RouterLink
        :to="{ name: 'offers' }"
        class="ml-2 md:ml-4 p-2"
        :class="currentRoute === 'offers' && 'bg-white text-black rounded-t'"
        v-if="auth.hasPermission('Tickets:offers_list')"
      >
        Overeenkomst
      </RouterLink>
      <RouterLink
        :to="{ name: 'meter-activation' }"
        class="ml-2 md:ml-4 p-2"
        :class="
          currentRoute === 'meter-activation' && 'bg-white text-black rounded-t'
        "
        v-if="auth.hasPermission('Eleena:register_meters')"
      >
        Meter activatie
      </RouterLink>
      <div class="my-auto px-2 ml-auto">
        <a
          href="https://solarmindsbv.sharepoint.com/sites/NormBibliotheek"
          target="_blank"
          class="flex items-center gap-1 bg-gray-200 text-black px-2 py-1 rounded-sm text-xs"
        >
          <PaperClipIcon class="h-4 w-4" />
          Bibliotheek
        </a>
      </div>
    </div>
  </nav>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useAuthStore } from '@/auth'
import {
  UserIcon,
  PaperClipIcon,
  ArrowUturnLeftIcon,
} from '@heroicons/vue/24/outline'
import { erpBaseUrl } from '@/erpMenu'

const route = useRoute()
const auth = useAuthStore()

const canUseErp = computed(() => auth.hasPermission('erp_user'))

const currentRoute = computed(() => {
  // Before the `offers` check below, which would claim 'installer-quotes' too.
  if (route.name?.startsWith('installer')) return 'installer'
  if (route.name?.includes('order')) return 'order'
  if (route.name?.includes('calendar') || route.query.from === 'calendar') {
    return 'calendar'
  }
  if (route.name?.startsWith('schedule')) return 'schedule'
  if (route.name?.startsWith('meter-activation')) return 'meter-activation'
  if (route.name?.includes('ticket')) return 'ticket'
  if (route.name?.includes('address-book')) return 'address-book'
  if (route.name?.includes('offers')) return 'offers'
  return route.name?.split('-')[0]
})
</script>
